<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
    <slot />
    <g :fill="color" fill-rule="evenodd">
      <path
        fill-rule="nonzero"
        d="M13.564 4.361c.215.174.248.489.075.703l-3.036 3.75c.246.333.397.74.397 1.186 0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2c.296 0 .574.068.827.184l3.034-3.748c.174-.215.488-.248.703-.075zM10 10c0-.552-.448-1-1-1s-1 .448-1 1 .448 1 1 1 1-.448 1-1zm8-1c0 1.65-.445 3.196-1.22 4.525-.176.3-.51.475-.858.475H2.078c-.348 0-.682-.174-.857-.475C.445 12.195 0 10.65 0 9c0-4.97 4.03-9 9-9s9 4.03 9 9zm-1 0c0-4.411-3.589-8-8-8S1 4.589 1 9c0 1.414.375 2.805 1.084 4.021L15.922 13C16.625 11.805 17 10.414 17 9z"
      />
      <circle cx="3" cy="9" r="1" />
      <circle cx="5" cy="5" r="1" />
      <circle cx="9" cy="3" r="1" />
      <circle cx="15" cy="9" r="1" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
